import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';

import { Form, FormTextField } from '@sbv-clients/ui-forms';
import {
  Button,
  Grid,
  Box,
  Typography,
  FormLabel,
} from '@sbv-clients/ui-shared';

import {
  authButtonSx,
  authFieldSx,
  authLabelSx,
} from '../../styles/auth-form.styles';
import { SharedSignInPageProps } from './index';
import { schema } from './scheme';

const defaultValues = schema.getDefault();

interface FormBodyProps {
  portal: SharedSignInPageProps['portal'];
}

const FormBody = ({ portal }: FormBodyProps) => {
  const { formState } = useFormContext();
  const { isSubmitting } = formState;
  return (
    <Grid container spacing={4}>
      <Grid size={12}>
        <FormTextField
          density={'comfortable'}
          fullWidth
          name="username"
          type="text"
          label="Username / Phone Number"
          labelSx={authLabelSx}
          sx={authFieldSx}
        />
      </Grid>
      <Grid size={12}>
        {portal === 'facility' ? (
          <Box display="flex" flexDirection="column" gap={2} width="100%">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <FormLabel sx={authLabelSx}>Password</FormLabel>
              <Link to="/auth/verify-phone">
                <Typography color="primary" fontWeight={700} fontSize={14}>
                  Forgot Password
                </Typography>
              </Link>
            </Box>
            <FormTextField
              density={'comfortable'}
              fullWidth
              name="password"
              type="password"
              sx={authFieldSx}
            />
          </Box>
        ) : (
          <FormTextField
            density={'comfortable'}
            fullWidth
            name="password"
            type="password"
            label="Password"
            labelSx={authLabelSx}
            sx={authFieldSx}
          />
        )}
      </Grid>
      <Grid size={12} pt={10}>
        <Button
          fullWidth
          type="submit"
          variant="contained"
          size="large"
          sx={authButtonSx}
          disabled={isSubmitting}
        >
          Login
        </Button>
      </Grid>
    </Grid>
  );
};

const SignInForm = ({ onSubmit, portal }: SharedSignInPageProps) => {
  return (
    <Form schema={schema} defaultValues={defaultValues} onSubmit={onSubmit}>
      <FormBody portal={portal} />
    </Form>
  );
};

export default SignInForm;
